<template>
    <ListItem
        :config="config"
        type="simple"
    />
</template>
<script setup>
    import ListItem from '@/components/modules/ListItem.vue'

    const props = defineProps({
        config: Object,
    })
</script>
